import React from "react";
import DynamoLayout from "../../components/dynamoLayout";

function Dynamo() {
  return (
    <>
      <DynamoLayout />
    </>
  );
}

export default Dynamo;
